export default __webpack_public_path__ + "static/media/09.ea59d47e.png";